/* import __COLOCATED_TEMPLATE__ from './additional-seats-price-badge.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();